module.exports = __webpack_public_path__ + "img/img_10.0218a260.png";